import React from "react";
import ReactDOM from "react-dom/client";
import "../node_modules/font-awesome/css/font-awesome.min.css";
import "../node_modules/bootstrap/dist/css/bootstrap.min.css";
import "aos/dist/aos.css";
import "./styles.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Provider } from "react-redux";
import store from "./redux/store";
import { CurrencyProvider } from "./context/CurrencyContext";
import CurrencyToast from "./components/CurrencyToast";
import WhatsAppFloat from "./components/WhatsAppFloat";
import AnalyticsManager from "./components/AnalyticsManager";

import {
  Home,
  Product,
  Products,
  AboutPage,
  ContactPage,
  Cart,
  Checkout,
  ComoComprarPage,
  PrivacyPage,
  PageNotFound,
} from "./pages";
import ScrollToTop from "./components/ScrollToTop";
import { Toaster } from "react-hot-toast";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <BrowserRouter>
    <ScrollToTop>
      <Provider store={store}>
        <CurrencyProvider>
          <AnalyticsManager />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/product" element={<Products />} />
          <Route path="/product/:slug" element={<Product />} />
            <Route path="/about" element={<AboutPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/cart" element={<Cart />} />
          <Route path="/checkout" element={<Checkout />} />
          <Route path="/como-comprar" element={<ComoComprarPage />} />
          <Route path="/privacy" element={<PrivacyPage />} />
          <Route path="*" element={<PageNotFound />} />
            <Route path="/product/*" element={<PageNotFound />} />
          </Routes>
          <CurrencyToast />
          <WhatsAppFloat />
        </CurrencyProvider>
      </Provider>
    </ScrollToTop>
    <Toaster />
  </BrowserRouter>
);
